import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

interface BreadcrumbPath {
  name: string;
  path: string;
}

interface Breadcrumb {
  title: string;
  pageBreadcrumbPath: Array<BreadcrumbPath>;
}

interface StoreInfo {
  breadcrumbs: Breadcrumb;
}

@Module
export default class BreadcrumbsModule extends VuexModule implements StoreInfo {
  breadcrumbs = {} as Breadcrumb;
  breadcrumbPath = {} as BreadcrumbPath;

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getBreadcrumbs(): Breadcrumb {
    return this.breadcrumbs;
  }

  /**
   * Get breadcrumb array for current page
   * @returns object
   */
  get pageBreadcrumbPath(): BreadcrumbPath {
    return this.breadcrumbPath;
  }

  /**
   * Get current page title
   * @returns string
   */
  get pageTitle(): string {
    return this.breadcrumbs.title;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_MUTATION](payload) {
    this.breadcrumbs = payload;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_PATH_MUTATION](payload) {
    this.breadcrumbPath = payload?.pageBreadcrumbPath;
  }

  @Action
  [Actions.SET_BREADCRUMB_ACTION](payload) {
    this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
  }

  @Action
  [Actions.SET_BREADCRUMB_PATH_ACTION](payload) {
    this.context.commit(Mutations.SET_BREADCRUMB_PATH_MUTATION, payload);
  }
}
